export default __webpack_public_path__ + "static/media/Search.6ef691b3.mp4";